import { ButtonIcon, InputForm } from '@components/index'
import { FIXED_TABLE_VALUES, ICreateTableSales, IFieldArray } from '@interfaces/tables/tableSales'
import React from 'react'
import { UseFieldArrayAppend, useFormContext } from 'react-hook-form'
import { IoAddOutline } from 'react-icons/io5'
import { TiDelete } from 'react-icons/ti'

interface IProps {
    columns: IFieldArray[]
    append: UseFieldArrayAppend<ICreateTableSales, 'columns' | 'rows' | `columns.${number}.cells` | `rows.${number}.cells`>
    removeColumn: (index: number) => void
    removeCells: (index: number) => void
}

export default function TableSaleHeader(props: IProps): React.ReactElement {
    const fixedValues = Object.values(FIXED_TABLE_VALUES) as unknown as string
    const { register } = useFormContext()

    return (
        <tr>
            {props.columns.map((field, index) => {
                const registerId = register(`columns.${index}.id`)
                const { ref: inputRef, ...inputProps } = register(`columns.${index}.name`)
                return (
                    <th key={index} className='col-head'>
                        <div className='box-content-cell'>
                            {fixedValues.includes(field.name ?? '')
                                ?
                                <></>
                                :
                                <div className='box-button-icon' >
                                    <ButtonIcon
                                        type='button'
                                        onClick={() => {
                                            props.removeColumn(index)
                                            props.removeCells(index)
                                        }}
                                        title='Remover Coluna'
                                    >
                                        <TiDelete size={25} />
                                    </ButtonIcon>
                                </div>
                            }
                            <input
                                {...registerId}
                                type='number'
                                value={index}
                                hidden
                            />
                            <InputForm
                                inputRef={inputRef}
                                {...inputProps}
                                type='text'
                                className='input-column'
                                style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '0.25rem',
                                    minWidth: '7.55rem'
                                }}
                                size='small'
                                disabled={fixedValues.includes(field.name ?? '')}
                            />
                        </div>
                    </th>
                )
            })}
            <th>
                <button
                    className='button-add-column'
                    type='button'
                    title='Adicionar Coluna'
                    onClick={() => props.append({ name: '' })}
                >
                    <IoAddOutline size={25} />
                </button>
            </th>
        </tr>
    )
}
